/*eslint-disable no-script-url*/

import React from 'react';
import { withRouter } from 'react-router-dom'
// import $ from 'jquery';

import Image1 from '../../../assets/images/img1.png';
import Image2 from '../../../assets/images/img2.png';
import Image3 from '../../../assets/images/img3.png';
import Image4 from '../../../assets/images/img4.png';
import Image5 from '../../../assets/images/img5.png';
import LogoText from '../../../assets/images/logo-txt.png';
import IcBlackDown from '../../../assets/images/ic_down-black.png';
import btnCancel from '../../../assets/images/ic_cancel_black.png';
import {PAGES} from "../../../common/Globals";
class Header extends React.Component {
    state = {
        isOpenInnerHeader: false
    };

    models = () => {
        if (this.props.models && this.props.models.length > 0) {
            return this.props.models.map((obj, index) =>
                <li onClick={() => this.props.handleModelSelect(obj)} key={index}>
                    <label className="control control--radio">
                        <p>{obj}</p>
                        <input defaultChecked={this.props.selectedModel === obj ? 'checked' : ''} type="radio" name="radio"/>
                        <div className="control__indicator"/>
                    </label>
                </li>
            )}
    };

    handleInnerHeaderShow = isOpenInnerHeader => this.setState({isOpenInnerHeader});

    render() {
        return (
            <header id='header'>
                <div className={'en-header'}>
                    <div className="top-header">
                        <div className="container">
                            <div className="row">

                                <div className="col-sm-6 col-xs-4 text-left">
                                    <a href="http://dicta.org.il/index-he.html">
                                        <em className="f black title" style={{fontStyle:'normal'}}>DICTA</em>
                                        <span className="txt add f black">Analytical tools for Hebrew texts</span>
                                    </a>
                                </div>
                                <div className="col-sm-6 col-xs-8 text-right">
                                    <div className="btn-group dropdown pull-right">
                                        <a href="javascript:void(0)" className="link dropdown-toggle f black" id="dropdownMenu2"
                                           data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            Dicta Tools <img alt="" src={IcBlackDown}/>
                                        </a>
                                        <ul className="dropdown-menu" aria-labelledby="dropdownMenu2">
                                            <li><a className="f black" href="http://server.dicta.org.il/#/searchStart"
                                                   target="_blank" rel="noopener noreferrer" > <span><img alt="" className="img" src={Image1}/></span>Search
                                                the Bible</a></li>
                                            <li><a className="f black" href=" http://dicta.org.il/nakdan/" target="_blank" rel="noopener noreferrer" >
                                                <span><img alt="" className="img" src={Image3}/></span> Nakdan</a></li>
                                            <li><a className="f black" href="http://server.dicta.org.il/#/classifyStart"
                                                   target="_blank" rel="noopener noreferrer" > <span><img alt="" className="img"
                                                                                                          src={Image2}/></span> Classify
                                                Biblical Texts</a></li>
                                            <li><a className="f black" href="http://pasuk.dicta.org.il"
                                                   target="_blank" rel="noopener noreferrer" > <span><img alt="" className="img"
                                                                                                          src={Image4}/></span> Pasuk Finder</a></li>
                                            <li><a className="f black" href="http://synoptic.dicta.org.il"
                                                   target="_blank" rel="noopener noreferrer" > <span><img alt="" className="img"
                                                                                                          src={Image5}/></span> Synoptic Builder</a></li>
                                        </ul>
                                    </div>
                                    <a onClick={() => this.props.handlePageState('he')} className="pull-right eng f black" id={'hebrew'} href="javascript:void(0)">עברית</a>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="inner-header">
                        <div className="container">
                            <div className="row">
                                <div className="col-sm-6 col-xs-8  pull-left">
                                    <div className="logo">
                                        <a href="javascript:void(0)">
                                            <span className="img"><img alt="" src={LogoText}/></span>
                                            <span className="f white">Tip of my tongue</span>
                                        </a>
                                        <a onClick={() => this.handleInnerHeaderShow(true)} className={'option-opener'}>{this.props.selectedModel} <i className={'fa fa-caret-down'}/></a>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-xs-4 pull-right">
                                    <a data-toggle="modal" data-target="#about"
                                       className="btn-header bt bt-sm pull-right active" >How to use</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`option-slider ${this.state.isOpenInnerHeader ? 'slide' : ''}`}>
                        {this.props.pageState === PAGES.EN ?
                            <div className={'container'}>
                                <ul>
                                    {this.models()}

                                </ul>
                                <a onClick={() => this.handleInnerHeaderShow(false)}
                                   className={'bt-close f black pull-right'} href="javascript:void(0)"><img alt=""
                                                                                                            src={btnCancel}/> Close</a>
                            </div> : null
                        }
                    </div>
                </div>
                <div className={'he-header'}>
                    <div className="top-header">
                        <div className="container">
                            <div className="row">

                                <div className="col-sm-6 col-xs-8 text-left">
                                    <div className="btn-group dropdown pull-left">
                                        <a href="javascript:void(0)" className="link dropdown-toggle f black" id="dropdownMenu2"
                                           data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            הכלים של Dicta   <img alt="" src={IcBlackDown}/>
                                        </a>
                                        <ul className="dropdown-menu" aria-labelledby="dropdownMenu2">
                                            <li><a className="f black" href="http://server.dicta.org.il/#/searchStart"
                                                   target="_blank" rel="noopener noreferrer" > <span><img alt="" className="img" src={Image1}/></span> חיפוש בתנ״ך
                                            </a></li>
                                            <li><a className="f black" href=" http://dicta.org.il/nakdan/" target="_blank" rel="noopener noreferrer" >
                                                <span><img alt="" className="img" src={Image3}/></span>  נקדן  </a></li>
                                            <li><a className="f black" href="http://server.dicta.org.il/#/classifyStart"
                                                   target="_blank" rel="noopener noreferrer" > <span><img alt="" className="img" src={Image2}/></span>
                                                סיווג טקסטים   </a></li>
                                            <li><a className="f black" href="http://pasuk.dicta.org.il"
                                                   target="_blank" rel="noopener noreferrer" > <span><img alt="" className="img"
                                                                                                          src={Image4}/></span>  איזכורים תנ״כיים  </a></li>
                                            <li><a className="f black" href="http://synoptic.dicta.org.il"
                                                   target="_blank" rel="noopener noreferrer" > <span><img alt="" className="img"
                                                                                                          src={Image5}/></span>  השוואת גרסאות </a></li>
                                        </ul>
                                    </div>
                                    <a onClick={() => this.props.handlePageState('en')} className="pull-left eng f black" id={'english'} href="javascript:void(0)">English</a>
                                </div>

                                <div className="col-sm-6 col-xs-4 text-right">
                                    <a href="http://dicta.org.il/index-he.html">
                                        <em className="f black title" style={{fontStyle:'normal'}}>DICTA</em>
                                        <span className="txt add f black">כלים דיגיטליים לעיבוד טקסטים בעברית</span>
                                    </a>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="inner-header">
                        <div className="container">
                            <div className="row">
                                <div className="col-sm-6 col-xs-4 pull-left">
                                    <a data-toggle="modal" data-target="#about"
                                       className="btn-header bt bt-sm pull-left active" >איך זה עובד</a>
                                </div>
                                <div className="col-sm-6 col-xs-8  pull-right">
                                    <div className="logo">
                                        <a href="javascript:void(0)">
                                            <span className="img"><img alt="" src={LogoText}/></span>
                                            <span className="f white">על קצה הלשון</span>
                                        </a>
                                        <a onClick={() => this.handleInnerHeaderShow(true)} className={'option-opener'}> {this.props.selectedModel} <i className={'fa fa-caret-down'}/></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`option-slider ${this.state.isOpenInnerHeader ? 'slide' : ''}`}>
                        {this.props.pageState === PAGES.HE ?
                            <div className={'container'}>
                                <ul>
                                    {this.models()}

                                </ul>
                                <a onClick={() => this.handleInnerHeaderShow(false)} className={'bt-close f black pull-left'} href="javascript:void(0)"><img alt="" src={btnCancel}/> סגור </a>
                            </div> : null
                        }

                    </div>
                </div>
            </header>
        );
    }

}
export default withRouter(Header);


// WEBPACK FOOTER //
// ./src/components/home/includes/Header.js